export const STATUS_CODE_NOT_FOUND = 404
export const STATUS_CODE_VALIDATION = 422
export const STATUS_CODE_PERMISSION = 417
export const STATUS_CODE_SERVER_ERROR = 500
export const STATUS_CODE_UNAUTHORIZED = 401
export const STATUS_CODE_FORBIDDEN = 403
